import { useGetAccountInfoQuery } from 'views/utils/graphql/graphql';

export const useAccountStatus = () => {
  const [accountInfo, _reload] = useGetAccountInfoQuery({ requestPolicy: 'network-only' });
  return {
    accountInfo,
  };
};
